import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgElevator = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 1.8,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: 4,
			y: 3,
			width: 16,
			height: 18,
			rx: 2
		}),
		/* @__PURE__ */ _jsx("polyline", { points: "8 9.5 10 7.5 12 9.5" }),
		/* @__PURE__ */ _jsx("polyline", { points: "12 14.5 14 16.5 16 14.5" })
	]
});
export default SvgElevator;
